// extracted by mini-css-extract-plugin
export var button = "_1n-1";
export var featuredLink = "_1n-4";
export var spinner = "_1n-2";
export var spinnerContainer = "_1n-3";
export var text = "_1n-0";